import { Button, Tooltip } from 'antd'
import { PermissionsGate } from 'features/permissions'
import { FileDiff } from 'lucide-react'
import { FC, useState } from 'react'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { LlmDiffDrawer } from './LlmDiffDrawer'

/**
 * Gecko-internal only: icon button that opens the LLM vs User diff drawer for
 * the current ticket. The drawer is lazily mounted so its data work only runs
 * while it is open.
 *
 * Placed in `LibraView`'s header next to `CommentSidebarToggle`. Invisible to
 * anyone without `PERMISSION_GECKO_INTERNAL_MEMBER`.
 */
export const LlmDiffLauncher: FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
      <Tooltip title='LLM vs User diff'>
        <Button type='text' onClick={() => setIsOpen(true)}>
          <FileDiff size={16} />
        </Button>
      </Tooltip>
      {isOpen && <LlmDiffDrawer onClose={() => setIsOpen(false)} />}
    </PermissionsGate>
  )
}
